import { useState } from 'react';
import { Phone, Mail, MessageSquare, X } from 'lucide-react';

function ContactWidget() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* Floating Contact Button */}
      {!isOpen && (
        <button
          onClick={() => setIsOpen(true)}
          className="fixed bottom-6 right-6 z-50 bg-gold hover:bg-gold-dark text-black font-bold p-4 rounded-full shadow-2xl transition-all transform hover:scale-110 flex items-center space-x-3"
          aria-label="Open contact options"
        >
          <MessageSquare className="w-6 h-6" />
          <span className="hidden sm:inline text-sm uppercase tracking-wider">Contact Us</span>
        </button>
      )}

      {/* Contact Widget Panel */}
      {isOpen && (
        <div className="fixed bottom-6 right-6 z-50 bg-black border-2 border-gold rounded-lg shadow-2xl w-80 sm:w-96">
          {/* Header */}
          <div className="bg-gold p-4 rounded-t-lg flex justify-between items-center">
            <div>
              <h3 className="text-black font-bold text-lg uppercase tracking-wide">Get In Touch</h3>
              <p className="text-black text-xs">We respond within 1 hour</p>
            </div>
            <button
              onClick={() => setIsOpen(false)}
              className="text-black hover:opacity-70 transition-opacity"
              aria-label="Close contact widget"
            >
              <X className="w-6 h-6" />
            </button>
          </div>

          {/* Contact Options */}
          <div className="p-6 space-y-4">
            <div className="text-gray-400 text-sm mb-4">
              Choose your preferred contact method:
            </div>

            {/* Call Now */}
            <a
              href="tel:9184933418"
              className="flex items-center space-x-4 bg-black border border-gold/30 hover:border-gold p-4 rounded-lg transition-all group"
            >
              <div className="bg-gold p-3 rounded-lg group-hover:scale-110 transition-transform">
                <Phone className="w-5 h-5 text-black" />
              </div>
              <div>
                <p className="text-white font-bold">Call Now</p>
                <p className="text-gold text-sm">(918) 493-3418</p>
              </div>
            </a>

            {/* Email Us */}
            <a
              href="mailto:inquire@williamsdiversified.com"
              className="flex items-center space-x-4 bg-black border border-gold/30 hover:border-gold p-4 rounded-lg transition-all group"
            >
              <div className="bg-gold p-3 rounded-lg group-hover:scale-110 transition-transform">
                <Mail className="w-5 h-5 text-black" />
              </div>
              <div>
                <p className="text-white font-bold">Email Us</p>
                <p className="text-gold text-sm">inquire@williamsdiversified.com</p>
              </div>
            </a>

            {/* Text/SMS */}
            <a
              href="sms:9184933418"
              className="flex items-center space-x-4 bg-black border border-gold/30 hover:border-gold p-4 rounded-lg transition-all group"
            >
              <div className="bg-gold p-3 rounded-lg group-hover:scale-110 transition-transform">
                <MessageSquare className="w-5 h-5 text-black" />
              </div>
              <div>
                <p className="text-white font-bold">Text/SMS</p>
                <p className="text-gold text-sm">(918) 493-3418</p>
              </div>
            </a>

            {/* 24/7 Notice */}
            <div className="bg-gold/10 border border-gold/30 rounded-lg p-4 mt-4">
              <p className="text-gold font-semibold text-sm text-center">
                24/7 Emergency Response Available
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ContactWidget;
